import { ReactNode } from 'react';
import clsx from 'clsx';

import classes from './hidotOvertimeReport.module.css';

type ReportSectionProps = {
  title: string;
  required?: boolean;
  value?: ReactNode;
  className?: string;
  children?: ReactNode;
};

const ReportSection = ({
  title,
  required,
  value,
  className,
  children,
}: ReportSectionProps) => {
  return (
    <div className={clsx(classes.sectionContainer, className)}>
      <div className={classes.sectionTitleContainer}>
        <div>
          {required && <span className={classes.requiredMarker}>*</span>}
          {title}
        </div>
        {value && <div>{value}</div>}
      </div>
      {children}
    </div>
  );
};

export default ReportSection;
